export const chainPromise = (callback, promise = Promise.resolve()) => promise.then(() => callback());
